import React from 'react';
import { useParams } from 'react-router-dom';
import './PaymentSuccess.css';

const ProjectSuccess = () => {
  const { invoiceId } = useParams(); // Get invoiceId from URL parameters

  return (
    <div className="payment-success-container">
      <div className="payment-success-card">
        <h1 className="payment-success-title">Registration Successful!</h1>
        <p className="payment-success-message">
         Your submission is under review.
         <br />
         Our team will get back to you soon.
        </p>
        <a href="/" className="payment-success-button">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default ProjectSuccess;